import { useEffect, useRef } from 'react'
import * as React from 'react'
import { useInView } from 'react-intersection-observer'
import { OFFER_TRACKING_IN_VIEW_THRESHOLD } from 'constants/offerList'
import type { CalendarMonthImpressionPrice } from './calendarMonthImpressionPrice'

interface Props {
  children: React.ReactNode
  scrollRoot: Element | null
  monthKey: string
  monthNumber: number
  year: number
  shouldTrack: boolean
  impressionPrice?: CalendarMonthImpressionPrice
  onImpression: (monthKey: string, monthNumber: number, year: number, impressionPrice?: CalendarMonthImpressionPrice) => void
}

function CalendarMonthPriceBlockImpression({ children, scrollRoot, monthKey, monthNumber, year, shouldTrack, impressionPrice, onImpression }: Props) {
  const trackedRef = useRef(false)
  const [ref, inView] = useInView({
    root: scrollRoot ?? undefined,
    threshold: OFFER_TRACKING_IN_VIEW_THRESHOLD,
    triggerOnce: true,
    skip: !shouldTrack,
  })

  useEffect(() => {
    if (inView && !trackedRef.current) {
      trackedRef.current = true
      onImpression(monthKey, monthNumber, year, impressionPrice)
    }
  }, [inView, onImpression, impressionPrice, monthKey, monthNumber, year])

  return <div ref={ref}>{children}</div>
}

export default CalendarMonthPriceBlockImpression
